import { render, staticRenderFns } from "./ReservationDashboard.vue?vue&type=template&id=77fb2827&scoped=true"
import script from "./ReservationDashboard.vue?vue&type=script&lang=js"
export * from "./ReservationDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReservationDashboard.vue?vue&type=style&index=0&id=77fb2827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb2827",
  null
  
)

export default component.exports